export default __webpack_public_path__ + "static/media/T346_RoHS.c403eb3f.pdf";